<template>
    <div class="productDetails">
      <div ref="contentRef" :style="contentStyle">
        <div v-html="props.description"></div>
      </div>
       <div v-if="showMoreButton" @click="toggleExpand" :class="[isExpanded? 'noExpanded':'isExpanded','showMoreButton']" > 
       
        <div class="textbut"> {{ isExpanded ? $t('setup460') : $t('setup459') }}<img v-if="isExpanded==false" src="../../../assets/images/xia.png" style="margin-left:6px;width: 10px;height: 7px;" /></div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, watch, nextTick } from 'vue';
  
  const props = defineProps(['description']);
  const emits=defineEmits(['getHeight'])

  const contentRef = ref(null);
  const isExpanded = ref(false);
  const contentHeight = ref(0);
  
  const contentStyle = computed(() => {
    if(contentHeight.value<300){
        return {
        overflow: 'hidden',
        height: isExpanded.value ? `${contentHeight.value}px` : 'auto',
        transition: 'height 0.3s ease',
        };
    }else{
        return {
          overflow: 'hidden',
          height: isExpanded.value ? `${contentHeight.value}px` : '300px',
          transition: 'height 0.3s ease',
        };
    }
  });
  
  const showMoreButton = computed(() => {
    return contentHeight.value > 300;
  });
  
  const toggleExpand = () => {
    isExpanded.value = !isExpanded.value;
    emits('getHeight')

  };
  
  // 监听 goods.description 的变化
  watch(
    () => props.description,
    () => {
      nextTick(() => {
        contentHeight.value = contentRef.value.scrollHeight;
      });
    },
    { immediate: true }
  );
  
  // 初始挂载时计算高度
  onMounted(() => {
    setTimeout(()=>{
      contentHeight.value = contentRef.value.scrollHeight;
    },1000)
    // nextTick(() => {
    //   contentHeight.value = contentRef.value.scrollHeight;
    // });
  });
  </script>
  
  <style scoped lang='scss'>
  button {
    margin-top: 10px;
    padding: 5px 10px;
    cursor: pointer;
  }

.productDetails{
  position: relative;
  .showMoreButton{
    position: absolute;
    width: 100%;
    background-image: url('@/assets/images/OcclusionBar.png');
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .textbut{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #888888;
      line-height: 12px;
      text-align: left;
      font-style: normal;
     padding-bottom: 7px;
    }
  }
  .isExpanded{
    // top: 88%;
    bottom: 0;

  }
  .noExpanded{
    // top: 98%;
    bottom: 0;
  }
}
  </style>